// extracted by mini-css-extract-plugin
module.exports = {"cardstyle":"Alert_cardstyle__15ars"};